module.exports = __webpack_public_path__ + "static/media/cb-build-profile-poster.e2fc298a.png";